<template>
  <Drawer
    :id="drawerId"
    title="Edit Mailing Markups"
  >
    <v-sheet
      v-if="open"
      class="mt-5 px-4"
    >
      <div
        v-for="item in optionGroups"
        :key="item.id"
        class="pb-4"
      >
        <OverrideMargin
          save-on-blur
          :label="item.name"
          :categoryId="categoryId"
          :coreProductId="coreProductId || undefined"
          :optionGroupId="item.id"
          cols="12"
          allow-all
        />
      </div>
    </v-sheet>
  </Drawer>
</template>

<script>
import { DRAWERS } from '@/utils/constants';
import Drawer from '@/components/layout/Drawer';
import { mapGetters } from 'vuex';
import { } from '@mdi/js';
import OverrideMargin from '@/components/print/margin/Override';
export default {
  name: 'MarginOptionsDrawer',

  components: {
    Drawer,
    OverrideMargin
  },

  data () {
    return {
      drawerId: DRAWERS.MARGIN_OPTIONS, categoryId: null, coreProductId: null, optionGroups: []
    };
  },

  computed: {
    open () {
      return this.drawerId === this.top_drawer.id;
    },
    ...mapGetters({
      initialData: 'drawers/data',
      drawerOpenedAt: 'drawers/lastOpenedAt',
      top_drawer: 'drawers/topDrawer'
    })
  },

  watch: {
    drawerOpenedAt (val, oldVal) {
      console.log('watch', val, oldVal, this.open, this.top_drawer);
      if (this.open) {
        const initial = this.initialData(this.drawerId) || {};
        console.log(initial);
        this.categoryId = initial.categoryId;
        this.coreProductId = initial.coreProductId;
        this.optionGroups = initial.optionGroups || [];
      }
    }
  },

  methods: {
  }
};
</script>
